import { Period } from '../../utils/types';

export const comparePeriodStartTime = (period1: Period, period2: Period): number => {
	const startTimePeriod1 = period1.source.startTime;
	const startTimePeriod2 = period2.source.startTime;
	if (!startTimePeriod1 && !startTimePeriod2) {
		return 0;
	}
	if (startTimePeriod1! < startTimePeriod2!) {
		return -1;
	}
	if (startTimePeriod1! > startTimePeriod2!) {
		return 1;
	}
	return 0;
};
